var map = {
	"./ask.svg": "TOLC",
	"./business.svg": "Br7G",
	"./category.svg": "3HFE",
	"./cgms.svg": "j/bu",
	"./chart.svg": "RjYk",
	"./chat.svg": "VxLz",
	"./common.svg": "TZay",
	"./currency.svg": "Fq0o",
	"./delivery0.svg": "WGpu",
	"./deliveryStaff.svg": "a7KV",
	"./dest.svg": "6fvU",
	"./dispatch.svg": "tVPt",
	"./download.svg": "+H2/",
	"./example.svg": "OOLB",
	"./external.svg": "4tNg",
	"./eye.svg": "4wdf",
	"./fileCheck.svg": "/ZdN",
	"./finance.svg": "pTuU",
	"./form.svg": "sTIr",
	"./freight.svg": "wbuy",
	"./gantan.svg": "+gFK",
	"./grant-coupon.svg": "LOQh",
	"./handle.svg": "cnev",
	"./home.svg": "U9Ws",
	"./import.svg": "XteN",
	"./inform.svg": "jBgF",
	"./invitation.svg": "W6jK",
	"./item.svg": "moUN",
	"./itemError.svg": "LYbj",
	"./list.svg": "vuHp",
	"./login-mall.svg": "xzZT",
	"./lost.svg": "YhLk",
	"./lottery.svg": "HVXl",
	"./map.svg": "maBF",
	"./marker.svg": "0+/s",
	"./member.svg": "/LrJ",
	"./msg.svg": "FfkO",
	"./msgboard.svg": "oX3V",
	"./order.svg": "gYtG",
	"./pack.svg": "vUpv",
	"./password.svg": "QjmH",
	"./pay.svg": "bVjv",
	"./pending.svg": "HJAH",
	"./people.svg": "GPe0",
	"./pickup-add.svg": "z9n4",
	"./pickup.svg": "TCIe",
	"./price.svg": "Y2tI",
	"./product.svg": "UHi4",
	"./promotion.svg": "HzCk",
	"./receive.svg": "KZYg",
	"./refund.svg": "GeoZ",
	"./report.svg": "2nwU",
	"./reward.svg": "lr47",
	"./scan.svg": "9oqM",
	"./scanBox.svg": "ZBqF",
	"./send.svg": "0zCS",
	"./setting.svg": "Kttn",
	"./shop-product.svg": "752c",
	"./shop.svg": "hert",
	"./size.svg": "Cr4N",
	"./sms-coupon.svg": "0Kk2",
	"./sms.svg": "AS+9",
	"./special.svg": "TgGA",
	"./stock.svg": "t+aG",
	"./timeout.svg": "+EHs",
	"./toPallet.svg": "gEUS",
	"./tracking.svg": "JpB5",
	"./transfer.svg": "S35e",
	"./tree.svg": "3eCm",
	"./ums-admin.svg": "FR/6",
	"./ums-menu.svg": "sr5k",
	"./ums-resource.svg": "noU8",
	"./ums-role.svg": "w7oB",
	"./ums.svg": "J4x9",
	"./unknown.svg": "wOos",
	"./upload.svg": "P/TB",
	"./urge.svg": "BYJz",
	"./user.svg": "VdD3",
	"./valid.svg": "fFbF",
	"./validImage.svg": "A4h+",
	"./warehouse.svg": "BupX",
	"./wechat.svg": "pYJ+",
	"./wx.svg": "TcIh"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 132